<template>
  <div>
    <!-- nav -->
    <headernav></headernav>
    <!-- banner -->
    <div class="banner">
      <!-- 验证码登录 -->
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        class="form verification SignIn"
        id="register"
      >
        <h2>欢迎注册能监宝</h2>
        <!-- <el-form-item prop="names" label="姓名"  class="tit-tel">
          <el-input placeholder="请输入姓名" v-model="ruleForm.names" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt=""> -->
        <el-form-item prop="tel" label="手机号" class="tit-pas">
          <el-input
            placeholder="请输入手机号"
            v-model="ruleForm.tel"
            @keyup.enter.native="submitForm('ruleForm')"
          ></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="" />
        <el-form-item prop="verification" label="验证码" class="tit-ver">
          <el-input
            placeholder="请输入验证码"
            v-model="ruleForm.verification"
            @keyup.enter.native="submitForm('ruleForm')"
          ></el-input>
          <div class="getsmscode" v-if="codecheck">{{ codetime }}秒后获取</div>
          <div class="getsmscode" @click="getver" v-else>获取验证码</div>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="" />
        <!-- <el-form-item prop="password" label="登录密码"  class="tit-pas">
          <el-input placeholder="请输入登录密码" v-model="ruleForm.password"  show-password @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="">
        <el-form-item prop="enterprise" label="企业名称"  class="tit-pas-sure">
          <el-input placeholder="请输入企业名称" v-model="ruleForm.enterprise" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="">
        <el-form-item prop="property" label="项目归属"  class="tit-pas-sure">
          <el-input placeholder="请输入项目归属产权人" v-model="ruleForm.property" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt=""> -->
        <!-- <div class="edg">已有能监宝账号？<router-link to="/index/yhdl">快捷登录<img src="../../assets/img/Path.png" alt=""></router-link></div> -->
        <el-button type="primary" @click="zhuce">注册</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import headernav from "../../components/common/headernav";
export default {
  name: "index",
  components: {
    headernav
  },
  data() {
    return {
      codecheck: false,
      codetime: 60,
      ruleForm: {
        names: "",
        tel: "",
        verification: "",
        password: "",
        enterprise: "",
        property: ""
      },
      rules: {
        names: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        tel: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        verification: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        enterprise: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        property: [
          { required: true, message: "请输入项目归属产权人", trigger: "blur" }
        ]
      },
      url: ""
    };
  },
  mounted() {
    this.url = this.global.baseUrl;
  },
  methods: {
    // 发送短信验证码
    getver() {
      if (this.ruleForm.tel == "") {
        this.$message.info("请输入手机号");
      } else if (!/^1\d{10}$/.test(this.ruleForm.tel)) {
        this.$message.info("手机号码格式不正确");
      } else {
        axios
          .post(
            `http://120.55.169.187:8881/news/sendValidCode?mobile=${this.ruleForm.tel}`,
            {}
          )
          .then(response => {
            if (response.data.code === 1) {
              this.$message.success("短信验证码发送成功");
              this.onTime();
            } else {
              this.$message.error(response.data.msg);
            }
          })
          .catch(err => {
            this.$message.error(response.data.msg);
          });
      }
    },
    // 注册
    zhuce() {
      if (this.ruleForm.tel != "" && this.ruleForm.verification != "") {
        axios
          .post(
            `${this.url}/news/addRegUser?&mobile=${this.ruleForm.tel}&cpType=1&validCode=${this.ruleForm.verification}`,
            {}
          )
          .then(response => {
            if (response.data.code === 1) {
              console.log(response.data);
              this.$message.success(response.data.msg);
              this.paslogin();
            } else {
              this.$message.error(response.data.msg);
            }
          })
          .catch(error => {
            this.$message.error(response.data.msg);
          });
      } else {
        this.$message.error("登录失败");
      }
    },
    paslogin() {
      axios
        .post(
          `${this.url}/news/regUserLogin?mobile=${this.ruleForm.tel}&code=${this.ruleForm.verification}`,
          {}
        )
        .then(response => {
          if (response.data.code === 1) {
            // window.location.href = `http://120.55.169.187:34362/#/index?userName=${response.data.data.userName}&password=${response.data.data.userPassword}`;
            // window.location.href = `http://120.55.169.187:34362/#/login?userName=${response.data.data.userName}&password=${response.data.data.userPassword}`
            window.location.href = `http://enterprise.freshpower.com.cn/#/login?userName=${response.data.data.userName}&password=${response.data.data.userPassword}`;
          } else {
            this.$message.error(response.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(response.data.msg);
        });
    },
    // 短信验证码60秒倒计时
    onTime() {
      var codetimes = 60;
      this.codecheck = true;
      this.codetime = 60;
      var setint = setInterval(() => {
        codetimes = --codetimes;
        this.codetime = codetimes;
        if (codetimes == 0) {
          this.codecheck = false;
          codetimes = 60;
          this.codetime = 60;
        }
      }, 1000);
      setint;
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/dlzc.css";
</style>



// WEBPACK FOOTER //
// src/pages/zc/zc.vue